import AssetLocationMap from "@/components/asset-location-map.jsx";
import CopyCoordinatesButton from "@/components/copy-coordinates-button.jsx";
import { hasAssetCoordinates } from "@/lib/asset-data-utils.js";

/**
 * Map panel with optional coordinate display and copy action for Asset Overview.
 * @param {{
 *   latitude: number|null,
 *   longitude: number|null,
 *   status: string,
 *   assetNumber: string,
 * }} props
 * @returns {JSX.Element}
 */
export default function AssetLocationPanel({
  latitude,
  longitude,
  status,
  assetNumber,
}) {
  const showCoordinates = hasAssetCoordinates(latitude, longitude);

  return (
    <div className='flex flex-col gap-3'>
      <AssetLocationMap
        latitude={latitude}
        longitude={longitude}
        status={status}
        assetNumber={assetNumber}
      />
      {showCoordinates && (
        <div className='flex flex-col items-end gap-2'>
          <p className='text-xs font-mono text-muted-foreground'>
            {latitude}, {longitude}
          </p>
          <CopyCoordinatesButton latitude={latitude} longitude={longitude} />
        </div>
      )}
    </div>
  );
}
